import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

/**
 * ExpansionBlueprintModal — the roadmap deep-dive triggered by the
 * NextDropBanner CTA. Investor / judge facing.
 */
export default function ExpansionBlueprintModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="expansion-blueprint-modal"
        className="bg-neutral-950 border-[#E5B83A]/40 text-white sm:max-w-[560px] max-h-[85vh] overflow-y-auto"
      >
        {/* Violet/blue accent stripe at the top — ties back to the banner */}
        <div className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-[#7c3aed] via-[#3b82f6] to-[#7c3aed] rounded-t-lg" />

        <DialogHeader>
          <DialogTitle className="font-display text-[22px] font-bold text-white leading-tight">
            FiguMatch — Expansion Blueprint
          </DialogTitle>
          <DialogDescription className="text-[#a1a1aa] font-body text-sm">
            The 3-phase path from World Cup 2026 to global collectibles hub
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-2">
          <PhaseCard
            testid="phase-card-1"
            chipLabel="SHIPPING NOW"
            chipClass="bg-[#E5B83A] text-black"
            title="Phase 1 — 2026 World Cup"
            highlight="LIVE"
            bullets={[
              "Panini-style 2026 World Cup sticker album (numbers 1–650)",
              "5km geolocation Radar with mutual-trade matching",
              "Polling chat + Official Safe Zones for in-person meetups",
              "Robo-Ball AI concierge (Claude Sonnet 4.5, jersey rotates with active matches)",
              "FiguTokens starter economy + viral share loop",
            ]}
            accent="#E5B83A"
          />
          <PhaseCard
            testid="phase-card-2"
            chipLabel="COMING SOON"
            chipClass="bg-[#8b5cf6] text-white"
            title="Phase 2 — Post-Tournament TCG Expansion"
            highlight="Q4 2026 – Q1 2027"
            bullets={[
              "Pokémon TCG — scan-to-inventory, set completion tracking, competitive-deck matchmaking",
              "Yu-Gi-Oh! — banlist-aware trade suggestions, region-specific edition tagging",
              "Dragon Ball Fusion World & Super Card Game — vintage + modern",
              "Universal card scanner (edge OCR) + condition grading assist",
            ]}
            accent="#8b5cf6"
          />
          <PhaseCard
            testid="phase-card-3"
            chipLabel="VISION"
            chipClass="bg-[#3b82f6] text-white"
            title="Phase 3 — 24/7 Global Collectibles Marketplace"
            highlight="2027+"
            bullets={[
              "Cross-border escrow with FiguTokens as settlement layer",
              "Automated bid/ask engine — set your wants and dupes, deals close while you sleep",
              "Verified vault storage partnerships for high-value cards",
              "Sponsor Safe Zone network scaled from local shops to global chains",
            ]}
            accent="#3b82f6"
          />
        </div>

        <p className="mt-5 pt-3 border-t border-white/10 text-[11px] italic text-[#71717a] font-body">
          Roadmap represents current product vision. Timelines subject to
          change. This card is for illustrative purposes.
        </p>
      </DialogContent>
    </Dialog>
  );
}

function PhaseCard({
  chipLabel,
  chipClass,
  title,
  highlight,
  bullets,
  accent,
  testid,
}) {
  return (
    <div
      data-testid={testid}
      className="rounded-xl border border-white/10 bg-[#0d0d0d] p-4"
      style={{ boxShadow: `0 0 0 1px ${accent}12 inset` }}
    >
      <div className="flex items-center gap-2 mb-2">
        <span
          className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-bold tracking-wider ${chipClass}`}
        >
          {chipLabel}
        </span>
        <span
          className="text-[11px] font-body uppercase tracking-widest"
          style={{ color: accent }}
        >
          {highlight}
        </span>
      </div>
      <h4 className="font-display text-white font-semibold text-[15px] mb-2">
        {title}
      </h4>
      <ul className="space-y-1.5">
        {bullets.map((b, i) => (
          <li
            key={i}
            className="flex gap-2 text-[12.5px] font-body text-[#d4d4d8] leading-[1.55]"
          >
            <span
              className="mt-1.5 h-1 w-1 rounded-full shrink-0"
              style={{ backgroundColor: accent }}
            />
            <span>{b}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
